import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { IconChartDonut2 } from "@tabler/icons-react";
import Pizza, { PizzaData } from "../../../util/charts/pizza";
import { map } from "lodash";
import MoedaText from "../../../util/ui/inputs/moedaText";
import PosicaoAtivo from "../../../../models/posicaoAtivo";
import { Moment } from "moment";
import { PieTooltipProps } from "@nivo/pie";
import FelixCard from "../../../util/ui/felixCard";
import ChartContainer from "../../../util/charts/chartContainer";
import { felixTokens, radius } from "../../../../theme";

export default function Custodia({
  custodia,
  dataFechamento,
}: {
  custodia: PosicaoAtivo[];
  dataFechamento?: Moment;
}) {
  const formatTooltip = (point: PieTooltipProps<PizzaData>) => {
    return (
      // Tooltip de gráfico: surface + hairline vindos do Card do tema, no
      // mesmo par sombra/radius dos tooltips de Análises.
      <Card
        elevation={0}
        sx={{ boxShadow: felixTokens.shadow.overlay, borderRadius: radius.sm }}
      >
        <Box display="flex" flexDirection="column" padding={1.5} gap={0.5}>
          <Typography
            variant="dataMono"
            color="text.primary"
            sx={{ fontWeight: 600 }}
          >
            {point.datum.data.label}
          </Typography>
          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="labelMono" color="text.secondary">
              Qtd:
            </Typography>
            <Typography variant="dataMono" color="text.primary">
              {point.datum.data.aux.quantidade}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="labelMono" color="text.secondary">
              PM:
            </Typography>
            <Typography variant="dataMono" color="text.primary">
              {<MoedaText value={point.datum.data.aux.precoMedio.toFixed(2)} />}
            </Typography>
          </Box>
        </Box>
      </Card>
    );
  };

  const data = map(custodia, (c) => ({
    value: c.quantidade * c.precoMedio,
    label: c.codigoAtivo,
    id: c.codigoAtivo,
    formatedLabel: c.codigoAtivo,
    aux: c,
  }));

  return (
    <FelixCard>
      <CardHeader title="Custódia" avatar={<IconChartDonut2 size={16} />} />
      <CardContent
        sx={{ display: "flex", flexDirection: "column", maxWidth: 408 }}
      >
        <ChartContainer
          height={360}
          emptyText="Mês ainda não calculado."
          isEmpty={!dataFechamento}
          isLoading={false}
        >
          <Pizza
            data={data}
            colorTheme="positives"
            formatTooltip={formatTooltip}
          />
          <Box alignSelf="flex-end">
            <Typography
              variant="dataMono"
              color="text.secondary"
              sx={{ fontSize: 11 }}
            >
              em {dataFechamento?.format("DD/MM/YY")}
            </Typography>
          </Box>
        </ChartContainer>
      </CardContent>
    </FelixCard>
  );
}
